module.exports = __webpack_public_path__ + "img/photo_2023-12-01 19.58.21.9f91646f.jpg";